import { API_BASE, tokenStore } from './client'

/**
 * Opens a document the API serves, in a new tab.
 *
 * <p>Not a plain link. The access token lives in memory — never in
 * `localStorage`, where an XSS would be an account takeover — so a new tab
 * carries no credential and the endpoint answers 401. This fetches the document
 * with the token the app already holds, then hands the browser a blob to
 * render, which is also what makes the browser's own "Save as PDF" work on it.
 *
 * @returns false when the document could not be fetched, so the caller can say
 *   so rather than leaving a blank tab open.
 */
export async function openDocument(path: string): Promise<boolean> {
  const token = tokenStore.get()
  const res = await fetch(`${API_BASE}${path}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    credentials: 'include',
  })
  if (!res.ok) return false

  const blob = await res.blob()
  const url = URL.createObjectURL(blob)
  const opened = window.open(url, '_blank', 'noopener')
  // Revoked on a timer rather than immediately: the new tab has to have read
  // it first, and there is no event that says it has.
  setTimeout(() => URL.revokeObjectURL(url), 60_000)
  return opened !== null
}
